export default __webpack_public_path__ + "static/media/astronaut.bba6815f.png";